// extracted by mini-css-extract-plugin
export default {"legalPage":"Legal_legalPage__X3x7A","content":"Legal_content__lC8fs","lastUpdated":"Legal_lastUpdated__8BR9N","section":"Legal_section__iVfmR"};